module.exports = __webpack_public_path__ + "0069829262a0609bf23e9eb022f4afc7.svg";